import React, { useEffect } from 'react';
import 'aos/dist/aos.css';
import AOS from 'aos';


const TransferOwnerShipModal = ({ isOpen, onClose, onConfirm, contactName }) => {
    useEffect(() => {
         AOS.init({ duration: 400 });
    }, []);

    if (!isOpen) return null;

    return (
        <div className={`fixed inset-0 z-50 flex items-center justify-center bg-[#00000061] transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0'}`} >
                   
            <div className={`bg-white rounded-[12px] w-[500px] py-6 px-[55px] shadow-[0 35px 30px 0_#15194b5e] text-center relative ${isOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0'}`} data-aos="zoom-in-left">
                
                {/* Close Button (top-right) */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-[#121212] text-[18px] font-bold"
                >
                    ×
                </button>

                {/* Title */}
                <h2 className="text-[14px] font-semibold text-primary-blue mb-2">
                    Transfer Ownership
                </h2>

                {/* Description */}
                <p className="text-[13px] text-primary-blue mb-6 fw-semibold">
                    Are you sure that you want to transfer ownership to {contactName}? This cannot be undone.
                </p>

                {/* Buttons */}
                <div className="flex justify-center gap-4">
                    <button
                        onClick={onConfirm}
                        className="bg-[#EA5145] hover:bg-[#d7372d] text-white text-[14px] font-medium px-6 py-2 rounded-[8px] w-full"
                    >
                        Confirm
                    </button>
                    <button
                        onClick={onClose}
                        className="border border-primary-blue text-primary-blue text-[14px] font-medium px-6 py-2 rounded-[8px] hover:bg-[#f5f5f5] w-full"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TransferOwnerShipModal;
